import { Outlet } from "react-router";

import MasterFormRoute from "./routes/MasterFormRoute";
import SettingsMasterFormListRoute from "./routes/SettingsMasterFormListRoute";

export const masterFormRoutes = [
    {
        path: "masterForm",
        handle: { breadcrumb: "masterForms:settingsMasterFormListRoute.title" },
        element: <Outlet />,
        children: [
            { index: true, element: <SettingsMasterFormListRoute /> },
            {
                path: ":masterFormType",
                handle: { breadcrumb: "masterForms:masterFormRoute.preciseLocationFormTitle" },
                element: <MasterFormRoute />,
            },
        ],
    },
];
